module.exports = __webpack_public_path__ + "img/idea.894622d9.png";